import { RouteAuthenticationRequirement, RouteItem } from '@cksoftware/react-base';
import { AppRoles } from '../constants/appRoles';
import { ApplicationRoutes } from '../constants/appRoutes';
import { Layout } from '../components/layout/layout';

export const StreamingNavItems: RouteItem = {
  text: 'Streaming',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [AppRoles.Admin],
  layout: <Layout />,
  subItems: [
    {
      text: 'Publish Stream',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: ApplicationRoutes.streaming.publishStream,
      allowedRoles: [AppRoles.Admin],
      async lazy() {
        const component = await import('../features/streaming/PublishStream');
        return { Component: component.PublishStream };
      }
    },
    {
      text: 'View Stream',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: ApplicationRoutes.streaming.viewStream,
      allowedRoles: [AppRoles.Admin],
      async lazy() {
        const component = await import('../features/streaming/ViewStream');
        return { Component: component.ViewStream };
      }
    }
  ]
};
